import React from "react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Shared empty / error panel for lists, dashboards, and POS.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
  tone = "default",
  className,
}) {
  const isError = tone === "error";
  const IconNode = icon ?? <Inbox size={compact ? 20 : 24} strokeWidth={1.75} />;

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        compact ? "px-4 py-8" : "px-6 py-12",
        className,
      )}
      role={isError ? "alert" : "status"}
    >
      <div
        className={cn(
          "mb-3 grid place-items-center rounded-2xl",
          compact ? "h-11 w-11" : "h-14 w-14",
          isError ? "bg-rose-50 text-rose-600" : "bg-stone-100 text-brand-primary",
        )}
        aria-hidden
      >
        {IconNode}
      </div>
      {title && (
        <p
          className={cn(
            "font-semibold",
            compact ? "text-sm" : "text-[15px]",
            isError ? "text-rose-800" : "text-stone-800",
          )}
        >
          {title}
        </p>
      )}
      {description && (
        <p className={cn("mt-1 max-w-sm text-stone-500", compact ? "text-xs" : "text-sm")}>
          {description}
        </p>
      )}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
